import { Text } from "@chakra-ui/react";

const RequiredIndicator = ({ value }: { value: any }) => {
  return value === null || value === undefined || value === "" ? (
    <Text
      as="span"
      role="presentation"
      aria-hidden="true"
      className="chakra-form__required-indicator"
      marginInlineStart="0.25rem"
      color="red.500"
    >
      *
    </Text>
  ) : null;
};

export default RequiredIndicator;
